export default __webpack_public_path__ + "static/media/whitePulumi.72f21514.svg";